module.exports = __webpack_public_path__ + "img/major5.52bbc6ba.png";